import { connect } from "react-redux"
import React, { Component } from "react"
import { createAction } from "redux-actions"

import {
  login,
  signup,
  EDIT_USER,
  CLEAR_VIDEOS,
  extConnect,
  LOGIN,
} from "../../actions"
import "./signin.css"
import "./signin.css"

const mapStateToProps = (state, ownProps) => {
  const { me } = state
  return {
    me,
    action: ownProps.action,
    buttonText: ownProps.buttonText,
    verificationRedirect: ownProps.verificationRedirect,
    onDone: ownProps.onDone
  }
}

class SignIn extends Component {
  constructor() {
    super()

    this.state = {}
  }

  reset() {
    this.props.dispatch(createAction(EDIT_USER)({ error: null, message: null }))
  }

  componentDidMount() {
    const { dispatch, onDone } = this.props
    const gInt = setInterval(() => {
      if (window.gapi) {
        clearInterval(gInt)
        window.gapi.signin2.render('my-signin2', {
          'scope': 'profile email',
          'width': 280,
          'height': 40,
          'longtitle': true,
          'theme': 'dark',
          'onsuccess': (googleUser) => {
            const id_token = googleUser.getAuthResponse().id_token;
            const profile = googleUser.getBasicProfile();
            const email = profile.getEmail()

            dispatch(
              extConnect(
                id_token,
                email,
                'google'
              )
            ).then(user => {
              googleUser.disconnect();
              onDone(user)
            })
          },
          'onfailure': (e) => {
            this.props.dispatch(createAction(LOGIN)(e))
            console.log("failure! ", e)
          }
        });
      } else {
        console.log("Google not loaded");
      }
    }, 100)
  }

  render() {
    const { dispatch, me, action, onDone, verificationRedirect } = this.props
    const self = this
    return (   
      <div className="signin-widget">
        <div id="my-signin2"></div>
        <button className="btn facebook-button" onClick={() => {
        console.log("Facebook button clicked")
          window.FB.login((response) => {
            let authResponse = window.FB.getAuthResponse()
            const authToken = authResponse.accessToken
            window.FB.api('/me', { locale: 'en_US', fields: 'name, email' },
              function(response) {
                dispatch(
                    extConnect(
                    authToken,
                    response.email,
                    'facebook'
                    )
                ).then(user => {
                    onDone(user)
                })
              }
            );
          }, {scope: "email"})
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 216" className="_5h0m" color="#ffffff">
        <path fill="#ffffff" d="M204.1 0H11.9C5.3 0 0 5.3 0 11.9v192.2c0 6.6 5.3 11.9 11.9
        11.9h103.5v-83.6H87.2V99.8h28.1v-24c0-27.9 17-43.1 41.9-43.1
        11.9 0 22.2.9 25.2 1.3v29.2h-17.3c-13.5 0-16.2 6.4-16.2
        15.9v20.8h32.3l-4.2 32.6h-28V216h55c6.6 0 11.9-5.3
        11.9-11.9V11.9C216 5.3 210.7 0 204.1 0z"></path>
        </svg>
        <span className="facebook-text">Continue with Facebook</span>
        </button>
        <div className="separator"><span>or {action == 'signup' ? 'sign up' : 'log in'} with email</span></div>
        <form
          onSubmit={async e => {
              e.preventDefault()
              this.reset();
              dispatch(createAction(CLEAR_VIDEOS)())
              let user;
              if (action === "signup") {
              user = await dispatch(
                  signup(
                  this.username.value,
                  this.password.value,
                  this.username.value,
                  verificationRedirect
                  )
              )
              } else {
              user = await dispatch(
                  login(this.username.value, this.password.value)
              )
              }
              onDone(user)
          }}  
        >
        <div className="form-group">
            <input
            type="text"
            className="form-control"
            onChange={e => this.setState({username: e.target.value})}
            placeholder={
                action === "signup"
                ? "Email address"
                : "Email or username"
            }
            autoComplete="username"
            ref={node => {
                this.username = node
            }}
            />
        </div>
        <div className="form-group">
            <input
            type="password"
            className="form-control"
            placeholder="Password"
            onChange={e => this.setState({password: e.target.value})}
            autoComplete={
                action === "signup"
                ? "new-password"
                : "current-password"
            }
            ref={node => {
                this.password = node
            }}
            />
        </div>
        {me.message != null
            ? <div
                className={`${me.error ? "error" : "info"} signin-alert`}
            >
                {me.message}
            </div>
            : ""}
        <button
            type="submit"
            className={`blue-button ${me.loggingIn ? 'disabled': ''}`}
            disabled={me.loggingIn || !this.state.password || !this.state.username}
        >
          {this.props.buttonText ? this.props.buttonText : action === "login" ? "Log In" : "Sign Up"}
        </button>
        <div style={{ clear: "both" }} />
        </form>
      </div>
    )
  }
}

export default connect(mapStateToProps)(SignIn)
